import styled from 'styled-components';
import { Fade } from '~/styles/animations';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: flex-start;
  justify-content: flex-start;
  padding: ${(props) => props.theme.spacing.xSmall} 0;
  position: relative;

  label {
    margin-left: 2px;
    font-weight: normal;
    color: ${(props) => props.theme.palette.gray3};
    text-transform: uppercase;
  }

  span {
    font-size: 12px;
    color: ${(props) => props.theme.palette.danger.main};
    margin: 2px;
    position: absolute;
    bottom: -6px;
    animation: ${Fade} linear forwards 0.5s;
  }

  input {
    border: 1px solid
      ${(props) =>
        props.error
          ? props.theme.palette.danger.main
          : props.theme.palette.gray4};
    border-radius: 0px 4px 4px 0px;
    border-left: none;
    padding: ${(props) =>
      `${props.theme.spacing.xSmall} ${props.theme.spacing.small}`};
    outline: none;
    font-size: 14px;
    transition: all ease 0.2s;
    flex: 1;

    &::placeholder {
      font-size: 14px;
      color: ${(props) => props.theme.palette.gray1};
    }
  }
`;
export const Box = styled.div`
  display: flex;
  width: 100%;
`;
